export default {
  methods: {
    renderReady: function (item) {
      return !(Object.entries(item).length === 0 && item.constructor === Object)
    }
  }
}

